import React, { useEffect, useState } from "react";
import axios from "axios";
import TextEditor from "../../../Components/RichTextEditor/TextEditor";
import { BASE_URL } from "../../../Config";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "../../../Components/Sidebar";
import "./AllPages.css";

import { Layout, Button, Card, Select, Typography } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import SuccessPopup from "../../../Components/popup/SuccessPopup";
import ErrorPopup from "../../../Components/popup/ErrorPopup";
import { MenuOutlined } from "@ant-design/icons";

const { Header, Content } = Layout;
const { Option } = Select;
const { Text } = Typography;


const REQUIRED_YOGA_TYPES = [
  "yoga",
  "meditations",
  "breathe-technique",
  "tool",
  "shatkarmas",
  "mudra",
  "dictionary",
];

const SHATKARMAS_OPTIONS = [
  { label: "Neti", value: "neti" },
  { label: "Dhauti", value: "dhauti" },
  { label: "Kapalbhati", value: "Kapalbhati" },
  { label: "Others", value: "others" },
];
const Warmup_Options = [
  { label: "Warmup", value: "Warmup" },
  { label: "Others", value: "others" },
];

const AllPages = () => {
  const [content, setContent] = useState("");
  const [page, setPage] = useState("");
  const [collapsed, setCollapsed] = useState(false);
  const [yogaType, setYogaType] = useState("");
  const [shatkarmasType, setShatkarmasType] = useState("");
  const [warmupType, setWarmupType] = useState("");
  const [dictionaryCategory, setDictionaryCategory] = useState("");
  const [dictionaryAlphabet, setDictionaryAlphabet] = useState("");

  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const [successPopup, setSuccessPopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const handleSubmit = async () => {
    const token = sessionStorage.getItem("token");

    if (!page) {
      alert("Please select a page!");
      return;
    }

    if (page !== "dictionary" && !content) {
      alert("Please enter content!");
      return;
    }

    if (page === "dictionary") {
      if (!dictionaryCategory || !dictionaryAlphabet) {
        alert("Please enter both Category and Alphabet content!");
        return;
      }
    }

    if (
      (REQUIRED_YOGA_TYPES.includes(page) || page === "warmup") &&
      !yogaType.trim()
    ) {
      alert("Please enter yoga type!");
      return;
    }

    if (page === "shatkarmas" && !shatkarmasType) {
      alert("Please select Shatkarmas Type!");
      return;
    }

    if (page === "warmup" && !warmupType) {
      alert("Please select Warmup Type!");
      return;
    }

    const body = {
      page,
      ...(page === "dictionary"
        ? {
          categoryContent: dictionaryCategory,
          alphabetContent: dictionaryAlphabet,
        }
        : { content }),

      ...((REQUIRED_YOGA_TYPES.includes(page) || page === "warmup") && {
        yogaType,
      }),
      ...(page === "shatkarmas" && { shatkarmasType }),
      ...(page === "warmup" && { warmupType }),
    };

    // const body = {
    //   content,
    //   page,
    //   ...((REQUIRED_YOGA_TYPES.includes(page) || page === "warmup") && {
    //     yogaType,
    //   }),
    //   ...(page === "shatkarmas" && { shatkarmasType }),
    //   ...(page === "warmup" && { warmupType }),
    // };

    try {
      setSubmitLoading(true);

      await axios.post(`${BASE_URL}/allpages`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setSuccessPopup(true);
    } catch (err) {
      console.error(err);
      setErrorPopup(true);
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}
        collapsedWidth="0"
        role="admin"
      />

      <Layout
        className="main-layout"
        style={{
          marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
          transition: "0.3s",
          padding: isMobile ? 10 : 20,
        }}
      >
        <Header
          className="MainHeader"
        >
          {isMobile && (
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setMobileOpen(true)}
              style={{ fontSize: 18, marginRight: 12 }}
            />
          )}
          <div style={{ flex: 1 }}>
            <Text style={{ fontSize: 20, fontWeight: "bold" }}>Add Pages</Text>
          </div>
        </Header>

        <Content style={{ padding: "20px" }}>
          <Card
            style={{
              borderRadius: 12,
              boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
              padding: 20,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 20,
              }}
            >
              <Typography.Title level={3} style={{ margin: 0 }}>
                Pages
              </Typography.Title>

              <Link to="/view-allpages">
                <Button type="primary">View All</Button>
              </Link>
            </div>

            <div style={{ marginBottom: 20 }}>
              <Typography.Text strong>Select Page</Typography.Text>

              <Select
                placeholder="Select a page…"
                value={page}
                onChange={setPage}
                style={{ width: "100%", marginTop: 8, height: 40 }}
              >
                <Option value="yoga">Yoga</Option>
                <Option value="breathe-technique">Breathe Technique</Option>
                <Option value="warmup">Warmup</Option>
                <Option value="alternate-asanas">Alternate Asanas</Option>
                <Option value="do-or-donts">Do or Don’ts</Option>
                <Option value="how-to-make-variation">
                  How to Make Variation
                </Option>
                <Option value="mudra">Mudra</Option>
                <Option value="meditations">Meditations</Option>
                <Option value="tool">Tool</Option>
                <Option value="time">Time</Option>
                <Option value="shatkarmas">Shatkarmas</Option>
                <Option value="dictionary">dictionary</Option>
              </Select>

              {(REQUIRED_YOGA_TYPES.includes(page) || page === "warmup") && (
                <div style={{ marginTop: 20 }}>
                  <Typography.Text strong>Yoga Name</Typography.Text>

                  <input
                    type="text"
                    placeholder="Enter yoga name…"
                    value={yogaType}
                    onChange={(e) => setYogaType(e.target.value)}
                    style={{
                      marginTop: 8,
                      width: "100%",
                      padding: "8px",
                      borderRadius: 6,
                      border: "1px solid #d9d9d9",
                      fontSize: 15,
                    }}
                  />
                </div>
              )}

              {page === "shatkarmas" && (
                <div style={{ marginTop: 20 }}>
                  <Typography.Text strong>Shatkarmas Type</Typography.Text>

                  <Select
                    placeholder="Select Shatkarmas Type"
                    value={shatkarmasType}
                    onChange={setShatkarmasType}
                    options={SHATKARMAS_OPTIONS}
                    style={{ marginTop: 8, width: "100%" }}
                  />
                </div>
              )}

              {page === "warmup" && (
                <div style={{ marginTop: 20 }}>
                  <Typography.Text strong>Warmup Type</Typography.Text>

                  <Select
                    placeholder="Select Warmup Type"
                    value={warmupType}
                    onChange={setWarmupType}
                    options={Warmup_Options}
                    style={{ marginTop: 8, width: "100%" }}
                  />
                </div>
              )}
            </div>

            {page === "dictionary" ? (
              <>
                <Typography.Title level={4} style={{ marginTop: 20 }}>
                  Dictionary – Category
                </Typography.Title>
                <div style={{ minHeight: 400 }}>
                  <TextEditor
                    initialData={dictionaryCategory}
                    onChange={setDictionaryCategory}
                    uploadUrl={`${BASE_URL}/upload`}
                  />
                </div>

                <Typography.Title level={4} style={{ marginTop: 30 }}>
                  Dictionary – Alphabet
                </Typography.Title>

                <TextEditor
                  initialData={dictionaryAlphabet}
                  onChange={setDictionaryAlphabet}
                  uploadUrl={`${BASE_URL}/upload`}
                />
              </>
            ) : (
              <TextEditor
                initialData={content}
                onChange={setContent}
                uploadUrl={`${BASE_URL}/upload`}
              />
            )}

            <Button
              type="primary"
              htmlType="submit"
              loading={submitLoading}
              disabled={submitLoading}
              style={{ marginTop: 20 }}
              onClick={handleSubmit}
            >
              {submitLoading ? "Uploading..." : "Upload Asana"}
            </Button>
          </Card>
          <SuccessPopup
            open={successPopup}
            message="Asana updated successfully!"
            onClose={() => {
              setSuccessPopup(false);
              navigate("/view-allpages");
            }}
          />

          <ErrorPopup
            open={errorPopup}
            message="Failed to update Asana!"
            onClose={() => setErrorPopup(false)}
          />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AllPages;
